import React, { useState, useEffect } from "react";

const EventLogItemExtra = (props) => {
  const { event, eventStore } = props;
  const [extraDisplay, setExtraDisplay] = useState();
  const ignoreSubTypes = ["drawn"];

  useEffect(() => {
    if (!ignoreSubTypes.includes(event.subType)) {
      switch (event.eventType) {
        case "foul":
          let filteredEvents = eventStore.filter(
            (ev) =>
              ev.eventType === event.eventType &&
              !ignoreSubTypes.includes(ev.subType) &&
              ev.personId === event.personId &&
              ev.eventTime <= event.eventTime &&
              ev.status !== "deleted"
          );
          if (event.personId) {
            setExtraDisplay(
              <span className={"foul-count foul-" + filteredEvents.length}>
                {filteredEvents.length}
              </span>
            );
          }
          break;
        default:
          break;
      }
    }

    // eslint-disable-next-line
  }, [event, eventStore]);
  return <>{extraDisplay}</>;
};

export default EventLogItemExtra;
